import { GAME_ID, REDUX_ACTIONS, BOT_FRAMES, BOT_ANIMATIONS } from '../../data/constants';

const initialState = {
  frame: BOT_FRAMES.IDLE,
  animate: BOT_ANIMATIONS.NONE,
};

// handles BotManager related data and actions

const botManagerReducer = (state = initialState, { gameId, type, payload = {} }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // update state when gamestate data has been received
    case REDUX_ACTIONS.PLAY_BOTS_ANIMATION:
      return {
        ...state,
        animate: payload.animation || BOT_ANIMATIONS.DEFAULT,
      };

    case REDUX_ACTIONS.END_BOTS_ANIMATION:
      return {
        ...state,
        animate: BOT_ANIMATIONS.NONE,
      };

    case REDUX_ACTIONS.SET_BOTS_FRAME:
      return {
        ...state,
        frame: payload.frame,
      };

    case REDUX_ACTIONS.DRAG_START:
      return {
        ...state,
        frame: BOT_FRAMES.LOOK_DOWN,
      };

    case REDUX_ACTIONS.DRAG_END:
      return {
        ...state,
        frame: BOT_FRAMES.IDLE,
      };

    default:
      return state;
  }
};

export default botManagerReducer;
